/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AdminContingentCreditsRequestDto { 
    credits?: number;
    target?: AdminContingentCreditsRequestDto.TargetEnum;
    reason?: string;
}
export namespace AdminContingentCreditsRequestDto {
    export type TargetEnum = 'CREDITS' | 'ADD_ON';
    export const TargetEnum = {
        CREDITS: 'CREDITS' as TargetEnum,
        ADDON: 'ADD_ON' as TargetEnum
    };
}